import React from 'react';
import { SimplePage } from '../components/shared/SharedComponents';
import { useContent } from '../hooks/useContent';
import { useScrollToTop } from '../hooks/useScrollToTop';

const IndustrialProducts = () => {
  useScrollToTop();
  const { industrialProducts } = useContent();

  return (
    <SimplePage
      title={industrialProducts.title}
      description={industrialProducts.description}
    />
  );
};

export default IndustrialProducts;